import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';
import { Moment } from 'moment';

export interface CashMovementListResponse {
  bankingEntryCode: number;
  code: string;
  launch: string;
  description: string;
  documentNumber: string;
  value: number;
  type: string;
  refund: boolean;
}

export type CashMovement = PageResult<CashMovementListResponse> & {
  previousBalance: number;
  currentBalance: number;
  totalDepartures: number;
  totalEntries: number;
  currentBalanceInPeriod: number;
};

export interface ListCashMovementQuery extends PageRequest {
  startDate?: string;
  finalDate?: string;
  companyIds?: number[];
  bankAccountIds?: number[];
}

export interface CashMovementFormValues {
  startDate?: Moment;
  finalDate?: Moment;
  companyIds?: number[];
  bankAccountIds?: number[];
  doNotViewRefund?: boolean;
}

export enum DateTypeEnum {
  Launch = 'LAUNCH',
  Conciliation = 'CONCILIATION',
}

export enum ReportTypeEnum {
  Geral = 'GENERAL',
  PlanAccount = 'PLAN_ACCOUNT',
}

export enum TypeOfMovementEnum {
  General = 'GENERAL',
  Tariffs = 'TARIFFS',
}

export interface CashMovementReportFormInterface {
  dateType: DateTypeEnum;
  documentTypeIds?: number[];
  planAccountIds?: number[];
  reportType: ReportTypeEnum;
  typeOfMovement: TypeOfMovementEnum;
  hidePreviousBalance: boolean;
}

export interface CashMovementReportRequestInterface
  extends CashMovementReportFormInterface {
  bankAccountIds?: number[];
  companiesIds?: number[];
  finalDate: string;
  format: string;
  initialDate: string;
}
